// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"340":"1b0eba6b031011dbf599","416":"c3a1ea81a9ad580f004e"}[chunkId] + ".css";
};